import { render, staticRenderFns } from "./PhpMonNotification.vue?vue&type=template&id=11a40ebe&scoped=true&"
import script from "./PhpMonNotification.vue?vue&type=script&lang=js&"
export * from "./PhpMonNotification.vue?vue&type=script&lang=js&"
import style0 from "./PhpMonNotification.vue?vue&type=style&index=0&id=11a40ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a40ebe",
  null
  
)

export default component.exports